import { Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress } from '@material-ui/core';
import React, { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { useObservable, useCallbackObservable } from 'react-use-observable';
import { of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import refundService from 'v2/services/requestManagement/refund';

import useStyle from './styles';

export default function ApproveMotive() {
  const classes = useStyle();
  const [open] = useObservable(() => refundService.getMassApprove(), []);
  const [refunds] = useObservable(() => refundService.list(), []);
  const [isSubmitting, setSubmitting] = useState<boolean>(false);

  const close = useCallback(() => {
    refundService.closeMassApprove();
  }, []);

  const [onSubmit] = useCallbackObservable(() => {
    setSubmitting(true);
    const checkedRefunds: string[] = (refunds || [])
      .filter((r) => r.checked)
      .map((r) => {
        return r.id;
      });
    return refundService.massApprove(checkedRefunds).pipe(
      tap(() => {
        setSubmitting(false);
        refundService.closeMassApprove();
        toast.success('Solicitações aprovadas com sucesso!');
      }),
      catchError((err) => {
        setSubmitting(false);
        toast.error(err);
        return of(true);
      })
    );
  }, [refunds]);

  const quantity = (refunds || []).filter((r) => r.checked).length;

  return (
    <Dialog aria-labelledby='customized-dialog-title' open={open} maxWidth={'sm'}>
      <DialogTitle id='customized-dialog-title'>
        <div className={classes.dialogTitle}>Aprovar Reembolso</div>
      </DialogTitle>
      <DialogContent dividers>
        Deseja aprovar <b>{quantity}</b> solicitações de reembolso ?
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={close} disabled={isSubmitting}>
          Cancelar
        </Button>
        <Button variant='contained' color='secondary' type='submit' disabled={isSubmitting} onClick={onSubmit}>
          Aprovar Reembolso
          {isSubmitting && <CircularProgress size={15} style={{ color: '#192542', marginLeft: 10 }} />}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
